// This icon file is generated automatically.
var PArrowrightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.58 5.62L5.68.5A.25.25 0 005.5.44H4.13a.12.12 0 00-.08.22L9.52 5.4H.38a.13.13 0 00-.13.12v.94c0 .07.06.12.13.12h9.14l-5.47 4.75a.12.12 0 00.08.22h1.43c.03 0 .06 0 .08-.03l5.94-5.15a.5.5 0 000-.76z", "fill-rule": "nonzero" } }] }, "name": "p-arrowright", "theme": "outlined" };
export default PArrowrightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PArrowRightOutlined.js
// module id = 3219
// module chunks = 0